export default "__VITE_ASSET__90850d66__"